import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=4e4310bb&lang=html"
import script from "./orderdetails.vue?vue&type=script&lang=js"
export * from "./orderdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports